import { apiFetch } from '@carouselgg/auth/client'

export interface DiscoverOrgGame {
  id: string
  name: string
  slug: string
  logo_url: string
}

export interface DiscoverOrg {
  id: string
  name: string
  slug: string
  description: string
  type: 'organization' | 'league' | 'university'
  logo_url: string
  primary_color: string
  recruiting_open: boolean
  registration_open: boolean
  university_name: string | null
  conference: string | null
  short_code: string | null
  member_count: number
  games: DiscoverOrgGame[]
}

export interface DiscoverOrgsResponse {
  organizations: DiscoverOrg[]
  total: number
  /**
   * Facet totals for the type filter, keyed by org type plus `all`. The API
   * computes these ignoring the type filter itself, so the counts stay put as
   * the visitor moves between facets.
   */
  type_counts: Record<string, number>
}

export interface DiscoverGameItem {
  id: string
  name: string
  slug: string
  logo_url: string
}

export async function discoverOrganizations(params: {
  type?: string
  game_id?: string
  q?: string
  limit?: number
  offset?: number
  sort?: string
}): Promise<DiscoverOrgsResponse> {
  const qs = new URLSearchParams()
  if (params.type) qs.set('type', params.type)
  if (params.game_id) qs.set('game_id', params.game_id)
  if (params.q) qs.set('q', params.q)
  if (params.sort) qs.set('sort', params.sort)
  qs.set('limit', String(params.limit ?? 24))
  qs.set('offset', String(params.offset ?? 0))
  return apiFetch<DiscoverOrgsResponse>(`/organizations/discover?${qs}`)
}

export async function getDiscoverGames(type?: string): Promise<DiscoverGameItem[]> {
  const qs = type ? `?type=${type}` : ''
  const res = await apiFetch<{ games: DiscoverGameItem[] }>(`/organizations/discover/games${qs}`)
  return res.games ?? []
}
